
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { ColorEnum } from '../../../enums/color.enum'
import { UiTooltip } from '../../keen-ui'

export default defineComponent({
  name: 'EpbBadge',
  components: {
    UiTooltip,
  },
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    color: {
      type: String,
      default: ColorEnum.BRAND_100,
    },
    icon: {
      type: String,
      default: undefined,
    },
    iconColor: {
      type: String as PropType<ColorEnum>,
      required: false,
      default: ColorEnum.WHITE,
    },
    tooltip: String,
    tooltipPosition: {
      type: String,
      default: 'bottom left',
    },
  },
  data() {
    return {
      baseClass: 'epb-badge',
    }
  },
})
